import React, { useState } from "react";
import { useSelector, useDispatch, useDispatchSync } from "react-redux";
import { Form, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { PDFPreviewList } from "../../component/pdfView";
import FormFilterDocument from "./FormFilterDocument";
import { getDataAction } from "../../config/redux/action";
import { Button as ButtonS } from "semantic-ui-react";
import { DC_DATA } from "../../constants";

export default () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [searchClick, setSearchClick] = useState(false);
  const { year, kuartal, company, companyName, reportType, data } = useSelector(
    (state) => state.documentReportReducer
  );

  const handleLihatDocument = (event) => {
    event.preventDefault();
    const path = `document/filter?year=${year}&kuartal=${kuartal}&perusahaanId=${company}&type=${reportType}`;
    dispatch(getDataAction({ path, type: DC_DATA }));
    setSearchClick(true);
  };

  React.useEffect(() => {
    if (searchClick) setShowModal(true);
  }, [data]);

  return (
    <>
      <div className="col-md-3">
        <div
          className="card container py-3 border-0"
          style={{ height: "100%" }}
        >
          <h3>Dokumen Laporan</h3>
          <Form className="mb-3" onSubmit={handleLihatDocument}>
            <FormFilterDocument />
            <ButtonS color="blue" block>
              Lihat Dokumen
            </ButtonS>
          </Form>
        </div>
      </div>

      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        size="lg"
      >
        <ModalHeader toggle={() => setShowModal(!showModal)}>
          {`Dokumen ${companyName}: Kuartal ${kuartal} tahun ${year}`}
        </ModalHeader>
        <ModalBody style={{ maxHeight: "calc(100vh - 210px)" }}>
          <PDFPreviewList data={data} />
        </ModalBody>
      </Modal>
    </>
  );
};
